export function ClubClothingAnnouncement() {
  return (
    <section>
      <div className="bg-white rounded-lg border border-neutral-200 shadow-soft p-6">
        <div className="text-center max-w-4xl mx-auto">
        <div className="space-y-4">
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4">
            <span className="inline-block px-3 py-1 bg-accent-600 text-white rounded-full text-sm font-bold animate-pulse">
              NEW
            </span>
            <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700">
              Club Logo Clothing
            </h2>
            <span className="inline-block px-3 py-1 bg-accent-600 text-white rounded-full text-sm font-bold animate-pulse">
              NEW
            </span>
          </div>

          <p className="text-base sm:text-lg font-body text-neutral-700">
            Browse our selection of club merchandise and apparel. See order form in left menu bar.
          </p>

          <div className="flex justify-center">
            <a
              href="/shop"
              className="inline-flex items-center px-6 py-3 bg-primary-600 text-white hover:bg-primary-700 rounded-lg font-semibold transition-colors"
            >
              Visit Club Shop
            </a>
          </div>

          <div className="bg-white rounded-lg p-4 mt-6 inline-block">
            <p className="text-neutral-700 font-medium">
              📬 Drop off order form with funds in Club Foyer Mailbox
            </p>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
}